import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    playIcon: {
      width: 21,
      height: 24,
      [theme.breakpoints.up('sm')]: {
        width: 33,
        height: 37,
        marginLeft: 8,
      },
    },
  }),
);
export default useStyles;
